import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { PropertyDebugResponse, getPropertyDebug, refreshPropertyDebug } from '~/services/AccommodationService';

export const propertyDebugQueryKeys = {
  all: ['propertyDebug'] as const,
  detail: (propertyId: string) => [...propertyDebugQueryKeys.all, 'detail', propertyId] as const,
};

interface UseGetPropertyDebugParams {
  propertyId: string;
  enabled?: boolean;
}

export function useGetPropertyDebug({ propertyId, enabled = true }: UseGetPropertyDebugParams) {
  return useQuery({
    queryKey: propertyDebugQueryKeys.detail(propertyId),
    queryFn: async () => {
      const response = await getPropertyDebug({ propertyId });
      return response.result;
    },
    enabled: enabled && !!propertyId,
  });
}

interface UseRefreshPropertyDebugParams {
  propertyId: string;
}

export function useRefreshPropertyDebug() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ propertyId }: UseRefreshPropertyDebugParams) => {
      const response = await refreshPropertyDebug({ propertyId });
      return response.result;
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData<PropertyDebugResponse>(propertyDebugQueryKeys.detail(variables.propertyId), data);
    },
  });
}
